'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeUtils = require('../../utils/typeUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function completeTypes(types) {
  var ignoredActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!(0, _typeUtils.isStringArray)(types)) {
    throw new Error('Types must be an array of strings');
  }
  if (!(0, _typeUtils.isStringArray)(ignoredActions)) {
    throw new Error('Exception cases from actions must be an array of strings');
  }

  var completedTypes = [];
  types.forEach(function (type) {
    completedTypes.push(type);
    completedTypes.push(type + '_SUCCESS');
    completedTypes.push(type + '_FAILURE');
  });

  return [].concat(completedTypes, (0, _toConsumableArray3.default)(ignoredActions));
}

exports.default = completeTypes;